/* eslint-disable consistent-return */
import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RecommendationsLayout } from '@beef/smart-kit';
import classNames from 'classnames/bind';

import { ContentWrap } from 'bricks';
import { getBasketData } from 'store/common/basket/selectors';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { setActiveCrossSellCategory } from 'store/ProductDetails/crossSellProducts/actions';
import {
  getCrossSellActivity,
  getCrossSellCategorys,
  getCrossSellCountToShowDesktop,
  getCrossSellCountToShowMobile,
  getCrossSellProductsListUpToCategory,
} from 'store/ProductDetails/crossSellProducts/selectors';

import CrossSellPopup from '../../widgets/CrossSellPopup';
import { CrossSellTabDevice } from './components/CrossSellTabDevice';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const getMappedTabs = (categories) =>
  categories.map((category) => ({
    id: category.id,
    isActive: category.active,
    title: category.text,
  }));

const CrossSellTab = () => {
  const dispatch = useDispatch();

  const {
    basketData,
    categorys,
    countToShowDesktop,
    countToShowMobile,
    isCrossSellPopupOpen,
    isMobile,
    list,
  } = useSelector(
    (state) => ({
      basketData: getBasketData(state),
      categorys: getCrossSellCategorys(state),
      countToShowDesktop: getCrossSellCountToShowDesktop(state),
      countToShowMobile: getCrossSellCountToShowMobile(state),
      isCrossSellPopupOpen: getCrossSellActivity(state),
      isMobile: isScreenBelow800(state),
      list: getCrossSellProductsListUpToCategory(state),
    }),
    shallowEqual,
  );

  const countToShow = isMobile ? countToShowMobile : countToShowDesktop;
  const visibleList = list.slice(0, countToShow);

  const mappedTabs = getMappedTabs(categorys);

  const onChangeTab = (id) => {
    const currentTab = mappedTabs.find((tab) => tab.id === id);

    if (currentTab) {
      dispatch(setActiveCrossSellCategory(currentTab.title));
    }
  };

  return (
    <div className={cx('wrap', isMobile && 'mobile')}>
      <ContentWrap size={['xl']}>
        {visibleList?.length && (
          <RecommendationsLayout
            captionSize="size3-m"
            devicesStatus="succeeded"
            label="Аксессуары"
            maxSlides={7}
            onChangeTab={onChangeTab}
            products={[]}
            tabVariant="secondary"
            tabs={mappedTabs.length > 2 && mappedTabs}
            tabsStatus="succeeded"
          >
            {visibleList.map((product) => (
              <React.Fragment key={product.name}>
                <CrossSellTabDevice
                  basketData={basketData}
                  product={product}
                  visibleList={visibleList}
                />
              </React.Fragment>
            ))}
          </RecommendationsLayout>
        )}
        {isCrossSellPopupOpen && <CrossSellPopup />}
      </ContentWrap>
    </div>
  );
};

export default CrossSellTab;
